<template>
  <el-container
    class="container-list is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋" v-model="keyword" class="input-with-select">
          <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
        </el-input>

        <!-- <el-select v-model="filteringStatus" @change="search" placeholder="篩選狀態" style="width: 120px;margin-left: 10px;">
          <el-option label="全部" value="全部"/>
          <el-option label="錯誤紀錄" value="錯誤紀錄"/>
        </el-select> -->
      </template>
      <template slot="right">
      <el-button @click="onExportExcel" style="margin-right: 20px;">匯出</el-button>
        <el-button v-if="$store.state.admin.AdminLevel >= 10000" @click="onCreate" style="margin-right: 20px;">新增</el-button>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading">
        <el-table :data="tableData" stripe height="calc(100% - 40px)" @sort-change="onTableSortChanged">
          <template slot="empty">沒有資料</template>
          <el-table-column label="名稱" min-width="160px">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.AdminLevel >= 10000" size="small">最高管理員</el-tag>
              <el-tag v-if="scope.row.AdminLevel == 1000" size="small">管理員</el-tag>
              <el-tag v-if="scope.row.AdminLevel == 100" size="small">會計</el-tag>
              <el-tag v-if="scope.row.AdminLevel == 10" size="small">部落客</el-tag>
              {{scope.row.Profile.Name}}
            </template>
          </el-table-column>
          <el-table-column label="帳號">
            <template slot-scope="scope">{{scope.row.Username ||
              (scope.row.FBID != '' ? 'FB登入' : null) ||
              (scope.row.LineID != '' ? 'Line登入' : null) ||
              (scope.row.AppleID != '' ? 'Apple登入' : null) ||
              (scope.row.GoolgeID != '' ? 'Google登入' : null)}}</template>
          </el-table-column>
          <el-table-column sortable :sort-orders="['descending','ascending',null]" label="訂單數量" width="120px">
            <template slot="header">
              <div class="cell" style="display: inline-flex; margin-right: 0">訂單數量
              </div>
            </template>
            <template slot-scope="scope">
              <div class="text-___" style="padding-right: 1vw">
                {{scope.row.Detail && scope.row.Detail.OrderCount}}
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable :sort-orders="['descending','ascending',null]" label="累積金額" width="120px">
            <template slot="header">
              <el-tooltip effect="dark" placement="bottom-start" content="只累積狀態為「已付款」的訂單金額" style="padding: 0;">
                <div class="cell" style="display: inline-flex; margin-right: 0">累積金額</div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="text-___" style="padding-right: 1vw">
                {{scope.row.Detail && scope.row.Detail.OrderAmountSum}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="購物金">
            <template slot-scope="scope">
              <div class="text-___" style="padding-right: 1vw">
                {{scope.row.Detail && scope.row.Detail.VoucherAmount}}
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable :sort-orders="['descending','ascending',null]" label="最後登入時間" width="180px">
            <template slot="header">
              <div class="cell" style="display: inline-flex; margin-right: 0">最後登入時間
              </div>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.Detail">{{scope.row.Detail.LastLoginedAt | moment}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" :width="`${$store.state.admin.AdminLevel >= 10000 ? '270px' : '150px'}`">
            <template slot-scope="scope">
              <el-button
                size="mini"
                round
                @click="$router.push({ name: 'user-detail', params: { id: scope.row.ID }, query: { frompage: currentPage, keyword: keyword, sorting: sortingJSON }})">
                檢視
              </el-button>
            <el-button
              size="mini"
              round
              @click="onUpdate(scope.row)">編輯</el-button>

            <el-button
              size="mini"
              round
              @click="onResetPassword(scope.row)">重置密碼</el-button>

            <el-button
              v-if="$store.state.admin.AdminLevel >= 10000"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager, next"
          :currentPage="currentPage"
          :page-size="countPerPage"
          :total="searchedObjs.length"
          @current-change="onChangePage"
        ></el-pagination>

        <user-profile-editor-modal :isShow="isShowAddeditModal" @close="isShowAddeditModal = false" @submitted="onObjAddedited" :ori-obj="editingObj"/>
        <add-modal :isShow="isShowAddModal" @close="isShowAddModal = false" @submitted="onObjAdded"/>

      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import UserProfileEditorModal from '@/data/user/view/modal-editor-profile.vue'
import AddModal from '@/data/user/view/modal-add.vue'
// svgs
import '@/assets/svgs/index.js'
// excel
import ExcelGenerator from '../excel'
import XLSXSaver from '@/utils/excel/xlsx-saver.js'
// mixin
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader,
    UserProfileEditorModal,
    AddModal
  },
  data () {
    return {
      countPerPage: 20,
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null,
      // modal
      isShowAddeditModal: false,
      editingObj: null,
      // modal add
      isShowAddModal: false,
      // sort
      sorting: {
        sortBy: null,
        sortOrder: null // asc or desc
      },
      // sort & back
      isRouterSortingLoaded: false
    }
  },
  computed: {
    isAdminList () {
      return this.$route.name == 'admin-list'
    },
    isUserList () {
      return !this.isAdminList
    },
    dataList () {
      let list = this.$store.state.user.list.filter(o => o.IsActive)
      list = list.filter(o => this.isAdminList ? o.AdminLevel > 1 : o.AdminLevel <= 1)
      return list
    },
    sortingJSON() {
      return JSON.stringify(this.sorting)
    }
  },
  methods: {
    onExportExcel () {
      this.loadSearchedUsersDetail().then(() => {
        try {
          let datas = this.searchedObjs
          let result = ExcelGenerator.generate(this, datas)

          var fileName = window.prompt(
            '請輸入匯出Excel檔之名稱',
            '旬果屋購物官網-會員匯出'
          )
          if (fileName === null) return // 取消
          if (!fileName) return window.alert('請輸入檔案名稱')
          XLSXSaver.saveAs(result, fileName)
        } catch (e) {
          alert('發生錯誤:' + e)
          window.console.error(`匯出異常`, e)
        }
      }).catch(this.$handleServiceError)
    },
    sortNeedsFullDetail (sortKey) {
      return ['訂單數量', '累積金額', '最後登入時間'].includes(sortKey)
    },
    onTableSortChanged (e) {
      this.handleSortChange(e.column.label, e.order)
    },
    handleSortChange (sortKey, sortOrder) {
      if (this.sortNeedsFullDetail(sortKey) && sortOrder) {
        return this.loadSearchedUsersDetail().then(() => {
          this.applySort(sortKey, sortOrder)
          this.refreshTableSlice()
        }).catch(this.$handleServiceError)
      }
      this.applySort(sortKey, sortOrder)
      this.refreshTableSlice()
      return this.loadCurrentPageUsersDetail()
    },
    applySort (sortKey, sortOrder) {
      console.log(`sortByOrderCount`, sortKey, sortOrder)
      try {
        this.sorting.sortBy = sortKey
        this.sorting.sortOrder = sortOrder
        this.currentPage = 1
        this.searchedObjs.sort((o1, o2) => {
          if (this.sorting.sortBy === '訂單數量') {
            return (this.sorting.sortOrder === 'ascending' ? 1 : -1) * ((o1.Detail && o1.Detail.OrderCount) - (o2.Detail && o2.Detail.OrderCount))
          } else if (this.sorting.sortBy === '累積金額') {
            return (this.sorting.sortOrder === 'ascending' ? 1 : -1) * ((o1.Detail && o1.Detail.OrderAmountSum) - (o2.Detail && o2.Detail.OrderAmountSum))
          } else if (this.sorting.sortBy === '最後登入時間') {
            return (this.sorting.sortOrder === 'ascending' ? 1 : -1) * ((moment(o1.Detail && o1.Detail.LastLoginedAt).unix() || 0) - (moment(o2.Detail && o2.Detail.LastLoginedAt).unix() || 0))
          } else {
            return -(o1.ID - o2.ID)
          }
        })

        console.log(`this.sorting =`, this.sorting)
      } catch (e) {
        console.error(e)
        alert(e)
      }
    },
    refreshTableSlice () {
      const start = (this.currentPage - 1) * this.countPerPage
      this.tableData = this.searchedObjs.slice(start, start + this.countPerPage)
    },
    loadCurrentPageUsersDetail () {
      const start = (this.currentPage - 1) * this.countPerPage
      const pageRows = this.searchedObjs.slice(start, start + this.countPerPage)
      const ids = pageRows.map(o => o.ID)
      if (ids.length === 0) return Promise.resolve()
      return this.$services.user.getUsersDetail(this, ids).then(res => {
        const usersDetail = res.data.result
        for (const data of pageRows) {
          const detail = usersDetail.find(o => o.UserID === data.ID)
          if (detail) {
            this.$set(data, 'Detail', detail)
          }
        }
      }).catch(this.$handleServiceError)
    },
    loadSearchedUsersDetail () {
      const ids = this.searchedObjs.map(o => o.ID)
      if (ids.length === 0) return Promise.resolve()
      return this.$services.user.getUsersDetail(this, ids).then(res => {
        const usersDetail = res.data.result
        for (const data of this.searchedObjs) {
          const detail = usersDetail.find(o => o.UserID === data.ID)
          if (detail) {
            this.$set(data, 'Detail', detail)
          }
        }
      }).catch(this.$handleServiceError)
    },
    applyRouteSortingThenLoadPage () {
      if (this.isRouterSortingLoaded || !this.$route.query.sorting) {
        return this.loadCurrentPageUsersDetail()
      }
      try {
        const sorting = JSON.parse(this.$route.query.sorting)
        const needBulk = this.sortNeedsFullDetail(sorting.sortBy) && sorting.sortOrder
        if (needBulk) {
          return this.loadSearchedUsersDetail().then(() => {
            this.applySort(sorting.sortBy, sorting.sortOrder)
            this.refreshTableSlice()
            this.isRouterSortingLoaded = true
          }).catch(this.$handleServiceError)
        }
        this.applySort(sorting.sortBy, sorting.sortOrder)
        this.refreshTableSlice()
        this.isRouterSortingLoaded = true
        return this.loadCurrentPageUsersDetail()
      } catch (e) {
        console.error(e)
        return this.loadCurrentPageUsersDetail()
      }
    },
    onCreate () {
      this.isShowAddModal = true
    },
    onUpdate (obj) {
      this.editingObj = obj
      this.isShowAddeditModal = true
    },
    onResetPassword (obj) {
      if (!window.confirm('密碼將重置為 1234，請重置後通知該使用者立即登入並修改密碼。\n\n確定重置密碼?')) return
      this.$services.user.resetPassword(this, obj.ID).then(res => {
        alert('密碼已經重置為 1234，\n請通知該使用者立即登入並修改密碼')
      }).catch(this.$handleServiceError)
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onObjAdded () {
      this.fetchUsers().then(this.searchWithoutAlertResult)
    },
    onChangePage (page) {
      this.currentPage = page
      this.refreshTableSlice()
      return this.loadCurrentPageUsersDetail()
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        let searchedObjs = this.dataList
        searchedObjs.sort((o1, o2) => -(o1.ID - o2.ID))
        this.searchedObjs = searchedObjs
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        if (o.Profile.Name && o.Profile.Name.includes(this.keyword)) return true
        if (o.Username && o.Username.includes(this.keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsError === (this.filteringStatus === '錯誤紀錄')
      }

      let searchedObjs = this.dataList.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })

      searchedObjs.sort((o1, o2) => -(o1.ID - o2.ID))
      this.searchedObjs = searchedObjs
    },
    resolve () {
      alert('todo')
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.Profile.Name}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.user.inActivate(this, obj.ID).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.user.list.findIndex(o => o.ID === obj.ID)
          if (idx >= 0) this.$store.state.user.list.splice(idx, 1)
          this.filterObjs()
          this.refreshTableSlice()
          this.loadCurrentPageUsersDetail()
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    fetchUsers () {
      return this.$services.user.getAll(this).then(res => {
        this.$store.state.user.list = res.data.result
      }).catch(this.$handleServiceError)
    },
    search () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = null
      this.filterObjs()
      this.currentPage = 1
      this.refreshTableSlice()
      this.alertSearchResult()
      return this.loadCurrentPageUsersDetail()
    },
    searchWithoutAlertResult () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = null
      this.filterObjs()
      this.currentPage = 1
      this.refreshTableSlice()
      return this.loadCurrentPageUsersDetail()
    }
  },
  created () {
    this.currentPage = parseInt(this.$route.query.page) || 1
    this.keyword = this.$route.query.keyword
    const initTableData = () => {
      this.filterObjs()
      this.refreshTableSlice()
      return this.applyRouteSortingThenLoadPage()
    }
    this.fetchUsers().then(initTableData)
  },
  watch: {
    $route (to, from) {
      this.searchWithoutAlertResult()
    }
  }
}
</script>
